import './Banner.css'

const Banner = () => {
    return (
        <header className='banner'>
            <img src="/imagens/banner.png" alt="O banner principal da página Little Jungle" />
        </header>
    )
}

export default Banner